import { render, staticRenderFns } from "./alarms.vue?vue&type=template&id=00e878a8&scoped=true&"
import script from "./alarms.vue?vue&type=script&lang=js&"
export * from "./alarms.vue?vue&type=script&lang=js&"
import style0 from "./alarms.vue?vue&type=style&index=0&id=00e878a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e878a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
